var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',{staticClass:"pt-0"},[_c('v-checkbox',{staticClass:"mt-0",attrs:{"label":"Mostrar cuentas cerradas","hide-details":""},model:{value:(_vm.cerradas),callback:function ($$v) {_vm.cerradas=$$v},expression:"cerradas"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }